import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "trm_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const authHeaders = () => {
    const t = getToken();
    return t ? { Authorization: `Bearer ${t}` } : {};
};

export const adminGet = (path) =>
    axios.get(`${API}${path}`, { headers: authHeaders() });

export const adminPost = (path, body) =>
    axios.post(`${API}${path}`, body, { headers: authHeaders() });

export const isAuthed = () => Boolean(getToken());

export const logout = () => {
    clearToken();
    window.location.href = "/admin/login";
};
